module.exports = __webpack_public_path__ + "img/monitoring-bus-selected.75c34d76.svg";